const draggable = "_35sd1t8s2kp";

export { draggable };
import "./atom.draggable.style.linaria.module.css";
//# sourceMappingURL=atom.draggable.style.js.map
